<template>
  <div class="main">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <van-dialog v-model="showDialog" title="信息" @closed="dialogCloseHandle()">
      <div v-if="loadingData" class="loading">
        <van-loading />
      </div>
      <div class="log" :style="'height: ' + (clientHeight - 300) + 'px'">
        <div v-for="item in dataList" :key="item.id">
          {{ `${item.saveTime || item.createDate}:${item.message}` }}
        </div>
      </div>
    </van-dialog>
    <van-tabbar v-model="active" route @change="onChange">
      <van-tabbar-item icon="flag-o" to="/task">任务</van-tabbar-item>
      <van-tabbar-item icon="diamond-o" to="/account">账号</van-tabbar-item>
      <van-tabbar-item icon="orders-o" to="/order">订单</van-tabbar-item>
      <van-tabbar-item icon="apps-o" to="/tools">工具</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/my">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      showDialog: false,
      loadingData: false,
      dataList: [],
    };
  },

  created() {
    this.$store.dispatch("updateServerList");
  },

  computed: {
    clientHeight: {
      get() {
        return this.$store.state.clientHeight;
      },
    },
    showLog: {
      get() {
        return this.$store.state.showLog;
      },
      set(val) {
        this.$store.commit("setShowLog", val);
      },
    },
    logId: {
      get() {
        return this.$store.state.logId;
      },
      set(val) {
        this.$store.commit("setLogId", val);
      },
    },
  },

  methods: {
    //获取活动推送
    async getSpringFestival() {
      if (localStorage.getItem("spring-festival") != "2025-01-21") {
        const { data: res } = await this.$http({
          url: "/spring-festival/info",
          method: "get",
        });
        if (res && res.code == 0) {
          localStorage.setItem("spring-festival", "2025-01-21");
          let total = res.data.order + res.data.grant + res.data.vip;
          if (total >= 1000) {
            let text;
            if (total <= 5000) {
              text = `充值10元可获得点券：1万+${total / 10000}万`;
            } else if (total <= 35000) {
              text = `充值50元可获得点券：7万+${total / 10000}万`;
            } else if (total <= 75000) {
              text = `充值100元可获得点券：15万+${total / 10000}万`;
            } else {
              text = `充值100元可获得点券：15万+7.5万`;
            }
            this.$dialog
              .alert({
                title: "您有返利等待使用",
                message: text,
                confirmButtonText: "活动详情",
                confirmButtonColor: "#ff0000",
              })
              .then(() => {
                this.$router.push({ name: "spring-festival" });
              });
          }
        }
      }
    },
    //获取用户消息
    getUserMessage() {
      this.$http({
        url: "/user-message/list",
        method: "get",
      }).then((value) => {
        const res = value.data;
        if (res && res.data && res.data.length > 0) {
          this.dataList = res.data;
          this.showDialog = true;
        }
      });
    },
    dialogCloseHandle() {
      this.showLog = false;
      if (this.dataList.length > 0 && !this.dataList[0].taskId) {
        let ids = this.dataList.map((item) => item.id);
        this.$http({
          url: "/user-message/delete",
          method: "post",
          data: ids,
        });
      }
    },
    onChange(index) {
      this.active = index;
      this.getUserMessage();
    },
    //展示日志信息
    async showLogMessage() {
      this.dataList = [];
      this.loadingData = true;
      this.showDialog = true;
      let { data: res } = await this.$http({
        url: "/script-log/list",
        method: "get",
        params: {
          taskId: this.logId,
        },
      });
      if (res.code === 0) {
        this.dataList = res.data;
        this.loadingData = false;
      }
    },
  },
  watch: {
    showLog(newValue, oldValue) {
      if (newValue) {
        this.showLogMessage();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  height: 100%;
  overflow-y: hidden;

  .van-dialog {
    .loading {
      width: 100%;
      height: 100px;
      position: relative;

      .van-loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .log {
      padding: 10px 5px;
      height: 100%;
      overflow-y: scroll;

      div {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>